import React from 'react';

import AuthForms, { AuthFormsProps } from '../AuthForms/AuthForms';
import ModalV2, { ModalV2Props } from '../Modal/ModalV2';

import styles from './authModal.module.less';

type AuthModalProps = Pick<AuthFormsProps, 'loginCallback' | 'signupLinkCallback'> &
  Omit<ModalV2Props, 'dialogHeadingId' | 'triggerRef'>;

export const AuthModal = ({
  loginCallback,
  signupLinkCallback,

  /** ModalV2Props */
  onClose,
  rootId,
}: AuthModalProps): JSX.Element => {
  return (
    <ModalV2
      dialogHeadingId="dialog-heading"
      lockBgScrolling
      onClose={onClose}
      rootId={rootId}
      triggerRef={null}
    >
      <div className={styles.authModalContent}>
        <AuthForms
          loginCallback={loginCallback}
          signupLinkCallback={signupLinkCallback}
          useRefactoredRecaptcha
        />
      </div>
    </ModalV2>
  );
};
